import React, { useState, useEffect } from 'react'
import { InvestmentTitleText } from 'src/components/Global/Text/TitleText'
import { CreateButton } from 'src/components/Global/Button/Button'
import { Link, useLocation } from 'react-router-dom'
import { Wrapper } from './styles'
import { useTypedSelector } from 'src/redux/root-reducer'
import { useDispatch } from 'react-redux'
import { getMyPlanAction } from 'src/redux/actions/planAction'
import { addNairaSign } from 'src/utils/addNairaSign'

const Plans = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getMyPlanAction())
  }, [dispatch])

  const myPlans = useTypedSelector(
    (state) => state.userPlanReducer.myPlans.plans
  )

  const Loading = useTypedSelector((state) => state.userPlanReducer.loading)

  console.log(myPlans)

  let location = useLocation()

  const [id, setId] = useState()

  return (
    <Wrapper>
      <div className="center">
        <div className="top">
          <InvestmentTitleText>General Plan</InvestmentTitleText>
          <p>Save for your periodic goals</p>
        </div>
        <Link to={`/create-target`} state={{ backgroundLocation: location }}>
          <CreateButton>Create</CreateButton>
        </Link>
      </div>
      {Loading && <h1>Loading...</h1>}
      {!Loading &&
        myPlans !== [] &&
        myPlans?.map(({ accrued_interest, balance, name, id, index }: any) => {
          return (
            <Link
              to={`/PlanDetail/${id}`}
              key={index}
              state={{ backgroundLocation: location }}
            >
              <div
                className="detail"
                key={index}
                onClick={(e) => {
                  setId(id)
                }}
                // onClick={() => dispatch(getMyPlanByIdAction(id))}
                // onClick={() => handleDetails(id)}
              >
                <div className="image"></div>
                <div className="content">
                  <div className="info">
                    <p className="name">{name}</p>
                    <p className="amount">{addNairaSign(balance)}</p>
                  </div>
                  <p className="interest">{addNairaSign(accrued_interest)}</p>
                  <div className="line"></div>
                </div>
              </div>
            </Link>
          )
        })}
    </Wrapper>
  )
}

export { Plans }
